<details>
  <summary (click)="openDetails(content)">
    <img width="30px" class="tool-icon" [src]="getToolIcon(content.tool)" />
    <hyperkit-typography
      variant="h5"
      display="inline"
      align="left"
      color="primary"
      >{{ content.tool }}</hyperkit-typography
    >
    <div>
      @for (
        category of content.deployment_requirements.categories;
        track category
      ) {
        <span>
          <hyperkit-badge
            variant="neutral"
            class="badge"
            text="{{ getReadableCategory(category) }}"
          ></hyperkit-badge>
        </span>
      }
    </div>
  </summary>
  <div class="content">
    <hyperkit-tab-bar variant="secondary" mode="underline">
      <hyperkit-tab text="Queries" [selected]="true">
        @if (generatedContentDetails) {
          <div class="py-3">
            @for (detail of generatedContentDetails.content; track detail) {
              <div class="query">
                <hyperkit-typography
                  variant="emphasized"
                  align="left"
                  color="primary"
                >
                  {{ content.title }}
                </hyperkit-typography>
                <div class="query-details">
                  <hyperkit-badge
                    variant="neutral"
                    text="{{ getReadableCategory(detail.category) }}"
                  ></hyperkit-badge>
                </div>
                <hyperkit-code-block
                  [code]="detail.query"
                  [copyable]="true"
                  (copied)="onCopy($event)"
                ></hyperkit-code-block>
              </div>
            }
          </div>
        }
      </hyperkit-tab>
      @if (generatedAddtionalContentDetails.length > 0) {
        <hyperkit-tab text="Additional Queries">
          @for (
            detail of generatedAddtionalContentDetails;
            track detail;
            let last = $last
          ) {
            <div class="py-3">
              @for (query of detail.content; track query) {
                <div class="query">
                  <hyperkit-typography
                    variant="emphasized"
                    align="left"
                    color="primary"
                  >
                    {{ content.title }}
                  </hyperkit-typography>
                  <div class="query-details">
                    <hyperkit-badge
                      variant="neutral"
                      text="{{ getReadableCategory(query.category) }}"
                    ></hyperkit-badge>
                  </div>
                  <hyperkit-code-block
                    [code]="query.query"
                    [copyable]="true"
                    (copied)="onCopy($event)"
                  ></hyperkit-code-block>
                </div>
              }
              @if (!last) {
                <hr />
              }
            </div>
          }
        </hyperkit-tab>
      }
      <hyperkit-tab text="Deployment Requirements" [hidden]="!hasDeploymentTab">
        <div class="py-3">
          @if (
            contentDetails?.deployment_requirements.searchable_data?.length
          ) {
            <div>
              <strong class="label">Searchable Data</strong>
              <p>
                {{
                  contentDetails?.deployment_requirements.searchable_data.join(
                    ', '
                  )
                }}
              </p>
            </div>
          }
          @if (
            contentDetails?.deployment_requirements.deployment_steps?.length
          ) {
            <div>
              <strong class="label">Deployment Steps</strong>
              <hyperkit-markdown
                [md]="contentDetails?.deployment_requirements.deployment_steps"
              ></hyperkit-markdown>
            </div>
          }
        </div>
      </hyperkit-tab>
    </hyperkit-tab-bar>
  </div>
</details>
